import React, { useEffect, useState } from "react";
import { getData, updateData } from "../../utils/firebase";
import { useSelector } from "react-redux";
import { getUid } from "../../redux/authSlice";
import { Box, Typography } from "@mui/material";
import Dialog from "../../components/dialog/dialog";
import { Button } from "../../components";
import constants from "../../config/constant";

export default function Notify() {
  const uid = useSelector(getUid);
  const [notification, setNotification]: any = useState();

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await getData(`dealers/${uid}/info/notice`);
        if (!response) return;

        Object.entries(response).forEach(([key, item]) => {
          if (item.role === "system") {
            const currentTimestamp = Date.now();
            const thirtyMinInMilliseconds = constants.TIMESTAMP; // 30 min in milliseconds
            const lastSeen = item.lastSeenTimestamp || 0;

            // Show notification if lastSeenTimestamp is undefined OR if it's older than 30 min
            if (currentTimestamp - lastSeen > thirtyMinInMilliseconds) {
              setNotification({ ...item, id: key }); // Create the updated notification
            }
          }
        });
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotification();
  }, [uid]);

  const handleClose = () => {
    setNotification(null);
  };

  const handleData = async () => {
    const currentTimestamp = Date.now();
    const path = `dealers/${uid}/info/notice/${notification?.id}`;
    const data = { lastSeenTimestamp: currentTimestamp };

    try {
      await updateData(path, data);
      handleClose();
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  const convertTime = (timestamp: string) => {
    const futureTimestamp = new Date(timestamp).getTime();
    // Current timestamp
    const currentTimestamp = Date.now(); // or new Date().getTime()
    // Calculate the difference in milliseconds
    const differenceInMilliseconds = futureTimestamp - currentTimestamp;
    // Convert the difference to days
    return Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
  };

  const convertText = (text: string) => {
    const differenceInDays = convertTime(notification?.timestamp);
    if (differenceInDays <= 0)
      return "Your account is about to be canceled. Please contact support at (888) 288-8856.";
    return text?.replace("{}", String(differenceInDays)); // Replace '{}' with 'differenceInDays'
  };

  const renderTitle = "Contact Support";

  const renderContent = (
    <Typography align="left">{notification?.text && convertText(notification?.text)}</Typography>
  );
  const renderActions = (
    <Box display={"flex"} justifyContent={"center"} width={"100%"} gap={1}>
      <Button onClick={handleClose} variant="outlined">
        Cancel
      </Button>
      <Button onClick={handleData} variant="contained">
        Ok
      </Button>
    </Box>
  );
  return (
    <Dialog
      open={Boolean(notification)}
      handleClose={handleClose}
      fullWidth
      renderContent={renderContent}
      renderTitle={renderTitle}
      renderActions={renderActions}
    />
  );
}
